module.exports = __webpack_public_path__ + "static/media/true_blood.e22dad07.jpg";